import apiClient from './apiClient';
import type { UploadedFile } from './becasApiService';

function asRecord(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' ? (value as Record<string, unknown>) : null;
}

function normalizeUploaded(raw: unknown): UploadedFile {
  const obj = asRecord(raw) ?? {};
  const nested = asRecord(obj.file) ?? obj;
  const id = String(nested.id ?? obj.id ?? '');
  const url = String(nested.url ?? obj.url ?? '');
  const fileName = String(nested.file_name ?? obj.file_name ?? '');
  if (!id) {
    throw new Error('File upload did not return an id');
  }
  return { id, url, file_name: fileName || undefined };
}

export const fileApiService = {
  async upload(file: File): Promise<UploadedFile> {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await apiClient.post<unknown>('/files/upload', formData);
    return normalizeUploaded(data);
  },
};

export default fileApiService;
